import { Download } from "lucide-react";
import { API } from "../lib/api";

// Renders a download link for a post attachment.
// `url` is the relative path returned by the backend, e.g. "/files/obfz-levice/uploads/.../x.pdf"
export default function AttachmentLink({ url, name, className = "" }) {
  if (!url) return null;
  const href = url.startsWith("http") ? url : `${API}${url}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="attachment-link"
      className={`inline-flex items-center gap-2 border-2 border-ink-900 bg-white px-4 py-2.5 font-heading font-bold text-sm text-ink-900 hover:bg-ink-900 hover:text-white transition-colors ${className}`}
    >
      <Download className="w-4 h-4 flex-shrink-0" />
      <span className="truncate">{name || "Stiahnuť prílohu"}</span>
    </a>
  );
}
